import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm p-8">
        <Link to="/" className="text-sm text-[#68caf1] hover:underline mb-6 inline-block">← Back to Home</Link>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-gray-400 mb-8">Last updated: July 31, 2025</p>

        <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
          <section>
            <h2 className="font-semibold text-gray-900 mb-2">1. Services</h2>
            <p>Monarch Detailing provides mobile auto detailing services in Southern Maryland. By booking a service, you agree to these terms.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">2. Deposits & Payments</h2>
            <p>A 50% deposit is required to confirm your booking. The remaining balance is due at the time of service. All payments are processed securely through Stripe.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">3. Cancellations & Rescheduling</h2>
            <p>Please provide at least 24 hours notice for cancellations or rescheduling requests. Late cancellations may result in forfeiture of your deposit.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">4. SMS Consent</h2>
            <p>By providing your phone number during booking, you consent to receive SMS messages from Monarch Detailing related to your service (confirmations, updates, invoices). Msg & data rates may apply. Reply <strong>STOP</strong> to opt out at any time. Reply <strong>HELP</strong> for assistance.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">5. Service Conditions</h2>
            <p>Additional charges may apply for excessive pet hair, heavy staining, or vehicle conditions requiring extra time and materials. You will be informed of any additional costs before work begins.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">6. Weather</h2>
            <p>Exterior services may need to be rescheduled due to severe weather. We will contact you as early as possible to arrange an alternative date.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">7. Liability</h2>
            <p>Monarch Detailing takes care to protect your vehicle. We are not responsible for pre-existing damage. Please note any existing damage before service begins.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">8. Contact</h2>
            <p>Questions? Email <a href="mailto:info.monarchdetailing@gmail.com" className="text-[#68caf1] hover:underline">info.monarchdetailing@gmail.com</a> or visit <a href="https://www.monarchdetailing.art" className="text-[#68caf1] hover:underline">monarchdetailing.art</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
